import type { ExecutionMode } from "@agency/core";
import { useT } from "../i18n";
import { Badge } from "./ui";

/** Honest provenance on every provider result: fixture = grey "Sample", sandbox = blue "Test", live = green "Live". */
export function ModeBadge({ mode, long }: { mode?: ExecutionMode | string | null; long?: boolean }) {
  const t = useT();
  const m = (mode ?? "fixture") as ExecutionMode;
  const tone = m === "live" ? "green" : m === "sandbox" ? "blue" : m === "disabled" ? "red" : "neutral";
  return (
    <Badge tone={tone} className="uppercase tracking-wide" >
      <span title={t(`mode.${m}.long`)}>{long ? t(`mode.${m}.long`) : t(`mode.${m}`)}</span>
    </Badge>
  );
}
